import axios, { AxiosResponse } from 'axios';
import { TopConfig } from '../context/ConfigContext';
import { HospitalList } from '../types/services';

export const getHospitalList = async (topConfig: TopConfig) => {
    const { resourceBundle } = topConfig.endpointConfig;
    const url = 'dk.claim-hospital-list';

    try {
        const response: AxiosResponse<Record<string, string>> = await axios(`${resourceBundle}/${url}`, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'GET'
        });

        if (response.status === 200) {
            if (response) {
                const hospitalList = Object.entries(response.data).map(([key, value]) => ({
                    label: value.trim(),
                    value: key
                }));

                //Danish alphabetical order is: A–Z, then Æ, Ø, Å.
                const sortedHospitalList: HospitalList = hospitalList.sort((a, b) =>
                    a.label.localeCompare(b.label, 'da')
                );
                sortedHospitalList.push({
                    label: 'Andet',
                    value: 'Andet'
                });

                return sortedHospitalList;
            }
        } else {
            return undefined;
        }
    } catch {
        // @TODO
        //  - Log that petclaim service malfunctioned
        throw new Error('Failed contacting the ResourceBundle(dk.claim-hospital-list)');
    }
};
